export const CALCULATE = 'CALCULATE'
export const CALCULATE_SUCCESS = 'CALCULATE_SUCCESS'
export const CALCULATE_ERROR = 'CALCULATE_ERROR'

export const RESET_CALCULATE = 'RESET_CALCULATE'